import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * Marks an `<ng-template>` as the group-header renderer for `adminui-autocomplete` (`[group]`).
 * Context: `$implicit` = the group object (`{ label, items }`).
 */
@Directive({
  selector: '[adminuiAutocompleteGroup]',
  standalone: true
})
export class AdminuiAutocompleteGroupDirective {
  readonly template = inject(TemplateRef<{ $implicit: any }>);
}
